import React from 'react';
import './App.css';

import HeaderContainer from "../HeaderContainer";
import FooterContainer from "../FooterContainer";
import PagesContainer from "../PagesContainer/PagesContainer";

class App extends React.Component {

    render() {
        return (
            <div className="App">
                <HeaderContainer/>
                <PagesContainer/>
                <FooterContainer/>
            </div>
        )
    }
}

export default App;
